<template>
  <div style="height: 100%">
    <div class="documentTop" :style="open ? 'height: 55%' : 'height: 100%'">
      <h3>Impala</h3>
      <div style="margin: 10px 0;">
        <Input
          v-model="docValue"
          clearable
          placeholder="Enter something..."
          style="width: 240px"
          @on-change="filterdocm(docValue)"
          icon="ios-search2"
        >
        </Input>
      </div>
      <el-tree
        :data="decoment"
        :props="defaultProps"
        accordion
        @node-click="handleNodeClick"
      >
      </el-tree>

      <!-- expand-node -->
      <!-- <h4 class="assist-inner-header">Query Analysis</h4>
      <p class="assist-no-entries" @click="open = true">
        No optimizations identified.
      </p> -->
    </div>
    <div v-show="open" class="documentBottom">
      <h3>{{ decomentTitle }}</h3>
      <!-- <br /> -->
      <p>{{ decomentText }}</p>
      <Icon class="close" size="24" type="md-close" @click="open = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      show: false,
      bottomShow: false,
      docValue: "",
      open: false,
      decoment: [],
      decomentList: [],
      decomentTitle: "",
      decomentText: "Bottom Pane",
      defaultProps: {
        children: "children",
        label: "title",
      },
    };
  },
  created() {
    this.getData();
  },
  components: {},
  computed: {},
  mounted() {
    // this.filterdocm();
  },
  methods: {
    //  获取impala文档
    getData() {
      axios.get("../../../../static/json/impala.json").then(
        (response) => {
          this.decomentList = response.data.impala;
          this.decoment = this.decomentList;
        },
        //
        (response) => {
          // console.log(response, "err");
        }
      );
    },
    // 点击目录
    handleNodeClick(data) {
      // console.log(data);
      if (!data.children) {
        this.open = true;
        this.decomentTitle = data.title;
        this.decomentText = data.description;
      }
    },
    filterdocm(val) {
      if (val) {
        this.decoment = this.decomentList.filter(
          (item) => item.title.toLowerCase().indexOf(val.toLowerCase()) != -1
        );
      } else {
        this.getData();
      }
    },
  },
};
</script>

<style scoped>
>>>.documentTop  .el-tree-node__expand-icon {
  color: #1D2129;
}

h3 {
  font-weight: normal;
}

.documentBottom {
  position: relative;
  padding: 10px 5px 0 0;
  border-top: 1px solid #ccc;
}
.documentBottom p {
  word-break: break-word;
}

.assist-inner-header {
  color: #5a656d;
  margin-left: 3px;
  margin-bottom: 2px;
  font-weight: bold;
  font-size: 14px;
}
.assist-no-entries {
  padding: 5px 10px;
  color: #838b92;
  font-style: italic;
  white-space: normal;
}
.close {
  position: absolute;
  top: 10px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/document.vue